module.exports = __webpack_public_path__ + "media/images/landing/en/planning-d5b502d46cfdf96504b6d4eed6016c2e.webp";